import React, { lazy } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { LazyRoute } from 'Modules'

const ProfileOrganizationLazy = lazy(
	() => import('Pages/profileOrganization/components/ProfileOrganization')
)

export const ProfileOrganizationRoutes = [
	<LazyRoute
		exact
		path={FrontUrls.partner_profile}
		lazyComponent={ProfileOrganizationLazy}
		key={FrontUrls.partner_profile}
	/>,
]
